import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { dispatch, useGlobalState } from '../../store/state';
import { Col, message, Result, Skeleton, Tabs } from 'antd';
import BaseLayoutComponent from '../../components/Layout/Admin/BaseLayoutComponent';
import TopSubHeaderComponent from '../../components/Admin/Common/TopSubHeaderComponent';
import FinanceWithdrawComponent from '../../components/Admin/Financials/FinanceWithdrawComponent';

const { TabPane } = Tabs;
export const AdminFinancePage = () => {
  const [user] = useGlobalState('user');
  useEffect(()=>{
  }, []);


  return (
    <BaseLayoutComponent>
      <TopSubHeaderComponent className="p-3 sticky">
        <h6 className="m-0"><strong>Financials</strong></h6>
      </TopSubHeaderComponent>
      <div className="px-3">
        <Tabs defaultActiveKey={'influencers'}
          size="small">
          <TabPane tab="Influencer Withdrawals"
            key="influencers">
            {/* <h3>Influ Withdrawls</h3> */}
            <FinanceWithdrawComponent withdrawType="influencers"/>
          </TabPane>
          <TabPane tab="Brand Withdrawals"
            key="brands">
            {/* <h3>Brand Withdrawls</h3> */}
            <FinanceWithdrawComponent withdrawType="brands"/>
          </TabPane>
        </Tabs>
      </div>
      {/* <div className="d-flex flex-wrap px-2">
                <div>
                    <h3>This is Finance Home</h3>
                </div>
            </div> */}
    </BaseLayoutComponent>
  );
};
